import CMX from "../../api";
import { fbqTrack } from "../analytics";

export function trackEvent(eventName, eventId, data) {
    CMX.post('/events-track/track', {
        event_name: eventName,
        event_id: eventId,
        event_time: Math.floor(Date.now() / 1000),
        data
    }).catch(error => {});
    
    // Meta Pixel
    fbqTrack(
        ['1132825914000332'],
        eventName,
        data,
        {eventID: eventId}
    );
}
